import React from 'react';
import { Login } from '../pages';
import { Session } from '../services';

export const Auth = ({ children }) => (Session.hasTokens() && !Session.showResetPopup() && !Session.needsTwoFaSetup() ? children : <Login />);
